import { Feed, getPersonFullName } from '@mntn-dev/ui-components'
import { ActivityTrans } from '../activity-trans.tsx'
import { Link } from '../index.ts'
import type { ActivityDetailsProps } from './types.ts'

export const PreProductionBrandFeedbackSubmitted = ({
  activity: {
    target,
    title,
    person,
    details: { activityType, data },
  },
  t,
  onNavigate,
  currentUrl,
}: ActivityDetailsProps<'pre_production_brand_feedback_submitted'>) =>
  person && (
    <>
      <Feed.Summary>
        <ActivityTrans
          t={t}
          i18nKey={`${activityType}.approved.${data.approved}.summary`}
          values={{
            subject: getPersonFullName(person),
            object: title,
          }}
        />
      </Feed.Summary>
      <Feed.Annotations>
        <Feed.Tag type={data.approved ? 'success' : 'error'}>
          {t(`${activityType}.approved.${data.approved}.status`)}
        </Feed.Tag>
        {target.fallbackUrn && (
          <Link
            {...{
              target: { name: title, urn: target.fallbackUrn },
              t,
              onNavigate,
              currentUrl,
            }}
          />
        )}
      </Feed.Annotations>
    </>
  )
